import Vue from 'vue';
/**
 * Ugly, but this is to get Froala to work without a global jquery, i.e. when we are using Vite (not Webpack)
 * @see {link: https://github.com/froala/react-froala-wysiwyg/issues/7#issuecomment-377401305}
 */
// import jQuery from "jquery";
import 'froala-editor/js/froala_editor.min.js';
// if (typeof FroalaEditor === 'function') FroalaEditor(jQuery)

import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
// import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/char_counter.min.js';

import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/font_family.min';
import 'froala-editor/js/plugins/font_size.min';


import VueFroala from 'vue-froala-wysiwyg';
// import 'froala-editor/js/plugins/help.min.js';
Vue.use(VueFroala);